const CompleteProfileActionType = {
  Error: "ERROR",
  UserCreateStarted: "USER_CREATE_STARTED",
  UserCreateStatusChanged: "USER_CREATE_STATUS_CHANGED",
} as const;

Object.freeze(CompleteProfileActionType);

export default CompleteProfileActionType;
